/**
 * Probe 이력의 표 소스.
 *
 * 조회는 페이지가 한다 — 폴링이 갱신한 Probe 와 이력이 같은 값을 봐야 하므로 소스가 따로 받지
 * 않고 **주어진 배열을 그대로 그린다.** 서버가 이미 최신순으로 주고 건수가 적어 페이지도 하나다.
 *
 * Owns:
 * - 주어진 Probe 배열 → 행 변환과 스냅샷 갱신.
 *
 * Does not own:
 * - 조회 · 폴링 — 페이지. 셀 표현 — `probeColumns.tsx`.
 */
import { DataTableSource } from "@carbon6/c6-frontend-design";
import type { DataTablePageResp } from "@carbon6/c6-frontend-design";
import type { Probe } from "../domain/probe";
import { ProbeTableRow } from "./ProbeTableRow";

export type ProbeTableSourceOptions = {
  onOpen: (probeUuid: string) => void;
  resolveErrorMessage: (error: unknown) => string;
};

export class ProbeTableSource extends DataTableSource<ProbeTableRow> {
  private readonly onOpen: (probeUuid: string) => void;
  private probes: readonly Probe[] = [];

  constructor({ onOpen, resolveErrorMessage }: ProbeTableSourceOptions) {
    super({ resolveErrorMessage });
    this.onOpen = onOpen;
  }

  /** 페이지가 받은(또는 폴링이 갱신한) 이력을 그대로 그린다. */
  async setProbes(probes: readonly Probe[]): Promise<void> {
    this.probes = probes;
    await this.refresh();
  }

  protected override async onPage(): Promise<DataTablePageResp<ProbeTableRow>> {
    const rows = this.probes.map((probe) => new ProbeTableRow(probe, { onOpen: this.onOpen }));
    return { rows, total: rows.length, page: 1, size: Math.max(rows.length, 1) };
  }
}
